import React from 'react';
import PropTypes from 'prop-types';
import { Box, TableCell, Typography, Avatar } from '@mui/material';
import bookmarkAddIcon from 'assets/activityIcons/bookmark.png';
import unbookmarkIcon from 'assets/activityIcons/unbookmark.png';
import clickedBuyIcon from 'assets/activityIcons/clickedBut.png';
import clickedMoreIcon from 'assets/activityIcons/clickedMore.png';
import rateIcon from 'assets/activityIcons/rate.png';
import followIcon from 'assets/activityIcons/follow.png';
import unfollowIcon from 'assets/activityIcons/unfollow.png';
import { getCellPadding } from 'helpers/tableStyleHelper';
import M from 'messages';
import classes from './styles';

const Activity = props => {
  const { data, cellItem } = props;
  const { cellPaddingRight, cellPaddingLeft } = cellItem;

  const activityTypeMapping = {
    clickedBuy: {
      icon: clickedBuyIcon,
      label: M.get('table.wineLoversActivities.filter.activityType.clickedBuy'),
    },
    clickedMore: {
      icon: clickedMoreIcon,
      label: M.get('table.wineLoversActivities.filter.activityType.clickedMore'),
    },
    rate: {
      icon: rateIcon,
      label: M.get('table.wineLoversActivities.filter.activityType.rate'),
    },
    bookmark: {
      icon: bookmarkAddIcon,
      label: M.get('table.wineLoversActivities.filter.activityType.bookmark'),
    },
    unBookmark: {
      icon: unbookmarkIcon,
      label: M.get('table.wineLoversActivities.filter.activityType.unBookmark'),
    },
    follow: {
      icon: followIcon,
      label: M.get('table.wineLoversActivities.filter.activityType.follow'),
    },
    unfollow: {
      icon: unfollowIcon,
      label: M.get('table.wineLoversActivities.filter.activityType.unfollow'),
    },
  };

  return (
    <TableCell
      align={cellItem.textAlign || 'left'}
      sx={classes.tableCellItem}
      style={{ ...getCellPadding(cellPaddingRight, cellPaddingLeft) }}>
      <Box sx={classes.content}>
        <Avatar src={activityTypeMapping[data.activity_type].icon} sx={classes.icon} />
        <Typography sx={classes.name}>{activityTypeMapping[data.activity_type].label}</Typography>
      </Box>
    </TableCell>
  );
};

Activity.propTypes = {
  data: PropTypes.shape({
    activity_type: PropTypes.string,
  }).isRequired,
  cellItem: PropTypes.shape({
    textAlign: PropTypes.string,
    cellPaddingRight: PropTypes.string,
    cellPaddingLeft: PropTypes.string,
  }),
};

export default Activity;
